import React from 'react';
import { bool, number, oneOf } from 'prop-types';

import LinearProgress from '@material-ui/core/LinearProgress';

import EsmsModal from '../../components/EsmsModal';

const ActionTitles = {
    create: 'Creating',
    delete: 'Deleting'
};

const ProfileObjectModificationModal = ({
    completed,
    modificationType,
    open,
    pending
}) => {
    return (
        <EsmsModal
            open={open}
            title={`${ActionTitles[modificationType]} Profile Objects...`}
        >
            <LinearProgress
                value={completed}
                valueBuffer={pending}
                variant="buffer"
            />
        </EsmsModal>
    );
};

ProfileObjectModificationModal.defaultProps = {
    completed:        0,
    modificationType: oneOf(Object.keys(ActionTitles)),
    open:             false,
    pending:          0
};

ProfileObjectModificationModal.propTypes = {
    completed: number,
    open:      bool,
    pending:   number
};

export default ProfileObjectModificationModal;
